//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { createFieldConfig } from '../../../../components/QSelectUtils.js'
import { parseUniqueKey } from '../ReportCheckListUniqueKey.js'
import FilesField from '../../../../components/File/FilesField.vue'
import FilesGroup from '../../../../components/File/FilesGroup.js'
import ItemsSearchField from '../../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    FilesField,
    ItemsSearchField
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      objectTypeFieldConfig: createFieldConfig({ allRecordsFn: () => Promise.resolve(this.standTypes) }),
      standTypes: [
        { id: 'trColon', name: 'Транспортная колонка' },
        { id: 'pedColon', name: 'Пешеходная колонка' },
        { id: 'consol', name: 'Консоль' },
        { id: 'doubleSupport', name: 'Опора двойного назначения ' },
        { id: 'steelSupport', name: 'Стальная опора' },
        { id: 'stand', name: 'Стойка' },
        { id: 'cutConsol', name: 'Усеченная консоль' },
        { id: 'mgoSupport', name: 'Опора МГО' },
        { id: 'ktoSupport', name: 'Опора КТО' }
      ]
    }
  },
  computed: {
    filesGroupToCheckForIgnoreDuplicate: function () {
      return this.report.filesGroupsContainers.guiImgFiles.getFilesGroup('other')
    }
  },
  methods: {
    onAddStand: function () {
      const stand = {
        objectType: null,
        comment: null,
        photo: [],
        photoQr: [],
        cladr: null,
        id: new Date().getTime()
      }

      this.resultValue.value.unshift(stand)
    },
    onDeleteStand: function (index) {
      this.resultValue.value.splice(index, 1)
    },
    onFileAddToUpload: function (fileWrapper, filesGroup) {
      const filesGroupProps = filesGroup.props
      if (filesGroupProps) {
        fileWrapper.attributes = {
          resultKey: filesGroupProps.resultKey,
          ...parseUniqueKey(this.resultValue.uniqueKey)
        }
      }
    },
    getFilesGroupPhoto: function (stand) {
      return this.getFilesGroup(stand, 'photo')
    },
    getFilesGroupPhotoQr: function (stand) {
      return this.getFilesGroup(stand, 'photoQr')
    },
    getFilesGroup: function (stand, type) {
      const filesProperty = 'guiImgFiles'
      const filesGroupsContainer = this.report.filesGroupsContainers[filesProperty]

      const key = `${this.resultValue.uniqueKey}_${type}_${stand.id}`
      let filesGroup = filesGroupsContainer.getFilesGroup(key)

      if (!filesGroup) {
        filesGroup = new FilesGroup({
          categoryKey: 'checkListSoStands',
          key: key,
          props: {
            resultKey: key
          }
        })
        filesGroupsContainer.addFilesGroup(filesGroup)
      }

      return filesGroup
    },
    onUploadSuccessPhoto: function ({ document }, stand) {
      return this.onUploadSuccess(document.id, stand, 'photo')
    },
    onUploadSuccessPhotoQr: function ({ document }, stand) {
      return this.onUploadSuccess(document.id, stand, 'photoQr')
    },
    onUploadSuccess: function (documentId, stand, property) {
      const s = this.resultValue.value.find(s => stand.id === s.id)
      s[property].push(documentId)
    },
    onRemovePhoto: function ({ file, filesGroup }, stand) {
      filesGroup.removeFile(file)
      return this.onRemove(file.id, stand, 'photo')
    },
    onRemovePhotoQr: function ({ file, filesGroup }, stand) {
      filesGroup.removeFile(file)
      return this.onRemove(file.id, stand, 'photoQr')
    },
    onRemove: function (fileId, stand, property) {
      const s = this.resultValue.value.find(s => stand.id === s.id)
      s[property] = s[property].filter(id => id !== fileId)
    }
  }
}

